export const actionTypes = {
    SET_AUDIO: 'SET_AUDIO'
};

export const setPlayable = (payload:any) => ({
    type: actionTypes.SET_AUDIO,
    payload,
});

